import { useEffect, useState } from "react";
import "./styles.scss";
import {
  fatchOffersByType,
  getAllTypeOffers,
} from "../../services/offers/offersApi";
import { toast } from "react-toastify";
import { formateCoins } from "../../function";
import { useTranslation } from "react-i18next";
import Loader from "../loader/loader";

function NewCollection(props) {
  const [typeOffers, setTypeOffers] = useState([]);
  const { t } = useTranslation();
  const [offers, setOffers] = useState([]);
  const [typeId, setTypeId] = useState(1);
  const { selectedOffer, setSelectedOffer } = props;
  const [isLoading, setIsLoading] = useState(true);
  // const [selectedOffer, setselectedOffer] = useState({});

  const fetchTypeOffers = async () => {
    try {
      const response = await getAllTypeOffers();
      setTypeOffers(response.data); // Assuming response.data contains the array of type offers
    } catch (error) {
      toast.error("Failed to fetch type offers"); // Notify error
    }
  };
  const fetchOffers = async (typeId) => {
    try {
      setIsLoading(true);
      await fatchOffersByType(typeId).then((res) => {
        setOffers(res.data.offres);
        setSelectedOffer(res.data.offres[0]);
        setIsLoading(false);
      });
    } catch (error) {
      toast.error("Failed to fetch type offers"); // Notify error
    }
  };

  useEffect(() => {
    fetchTypeOffers();
  }, []);

  useEffect(() => {
    fetchOffers(typeId);
  }, [typeId]);

  const buttonIcon = (type) => {
    if (type === "XBOX") {
      return <i className="bi bi-xbox mr-3"></i>;
    } else if (type === "PC") {
      return <i className="bi bi-pc mr-3"></i>;
    } else {
      return <i className="bi bi-playstation mr-3"></i>;
    }
  };

  return (
    <>
      {isLoading ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "80vh",
          }}
        >
          <Loader />
        </div>
      ) : (
        <>
          <div className="row mt-4" >
            <div className="col-12 mb-2">
              <div className="sub-heading " style={{ fontSize: "16px" }}>
                {t("CHOOSE YOUR PLATFORM")}
              </div>
            </div>
            <div
              className="card-selection-container mt-1"
              role="listbox"
              aria-label="Select Type"
            >
              {typeOffers.map((M) => (
                <button
                  key={M.id}
                  role="option"
                  aria-selected={typeId === M.id}
                  className={`card-selection-option-tayar mr-4  ${typeId == M.id ? "selected-tayar-botton" : ""}`}
                  onClick={() => setTypeId(M.id)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                      e.preventDefault();
                      setTypeId(M.id);
                    }
                  }}
                  tabIndex={0}
                >
                  <span className="py-2">{buttonIcon(M.nom)}</span>
                  <span>{M.nom}</span>
                </button>
              ))}
            </div>
          </div>

          <div className="new_offers_radio_group_container">
            <div className="mb-3 mt-0 pt-0">
              <div className="sub-heading poupel" style={{ fontSize: "16px" }}>
                {t("SELECT COIN AMOUNT")}
              </div>
            </div>

            <div
              className="new_offers_radio_group"
              role="radiogroup"
              aria-label="radio-group"
            >
              {offers.map((option) => (
                <label
                  key={option.value}
                  onClick={() => setSelectedOffer(option)}
                  className={`new_offers_radio_label ${selectedOffer.id === option.id ? "selected_new_offers_radio_label" : ""}`}
                >
                  {/* <span className="new_offers_radio_input_wrapper">
              <input
                type="radio"
                name="new_offers_amount"
                value={option.id}
                
                // defaultChecked={option.checked}
                className="new_offers_radio_input"
              />
              
            </span> */}

                  <span className="new_offers_radio_content">
                    <div className={`new_offers_radio_card `}>
                      <div className="new_offers_radio_card_main">
                        <img
                          src="/images/cheapest-players-fut.webp"
                          alt="fut icon"
                          className="new_offers_radio_icon"
                        />
                        <strong className="new_offers_radio_amount">
                          {formateCoins(option.coins)}
                        </strong>
                      </div>

                      {option.promotion && option.promotion > 0 && (
                        <div className="new_offers_radio_bonus">
                          <div className="new_offers_radio_bonus_text">
                            - {option.promotion} %
                          </div>
                        </div>
                      )}
                    </div>
                  </span>
                </label>
              ))}
            </div>
          </div>
        </>
      )}
    </>
  );
}

export default NewCollection;
